import { Disclosure } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Example(props) {

  const navigation = [
    { name: 'Bon cadeaux', href: 'https://www.kalendes.com/site/instantbienetrecoralie/gift', target: '_blank', current: false },
    { name: 'Nos soins', href: '#soins', current: false, onClick: () => props.scroll('soins') },
    { name: 'Nos massages', href: '#massage', current: false, onClick: () => props.scroll('massage') },
    { name: 'Notre équipe', href: '#team', current: false, onClick: () => props.scroll('team') },
    { name: 'Contactez-nous', href: '#contact', current: false, onClick: () => props.scroll('contact') },
]

  
  return (
    <Disclosure as="nav" className="bg-[#FDF5F1]">
      {({ open }) => (
        <>
          <div className='mr-5'>
            <div className="relative flex h-16 items-center justify-between">
              <span className='font-poppins text-black font-medium ml-5 lg:block nav:hidden'>Instant bien être</span>
              <img className='w-24 ml-3 mt-4' src='/images/instant.png' alt='logo' />
              <div className="absolute inset-y-0 right-0 flex items-center nav:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6 text-black" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6 text-black" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-end">
                <div className="flex flex-shrink-0 items-center">
                </div>
                <div className="hidden sm:ml-6 nav:block">
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        target={item.target}
                        href={item.href}
                        onClick={item.onClick}
                        className={classNames(
                          item.current ? 'bg-gray-900 text-white' : 'font-poppins text-black',
                          'rounded-md px-3 py-2 text-sm font-medium'
                        )}
                        aria-current={item.current ? 'page' : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:block">
            <div className="space-y-1 px-2 pb-3 pt-2">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current ? 'bg-gray-900 text-white' : 'font-poppins text-black',
                    'block rounded-md px-3 py-2 text-base font-medium'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}
